import { Injectable } from '@angular/core';
import { Firestore, collectionData, collection, query, where, doc, getDoc, updateDoc } from '@angular/fire/firestore';
import { Observable, map, switchMap, of, combineLatest } from 'rxjs';
import { User } from '../models/user.model';
import { Rental } from '../models/rental.model';
import { RentalService } from './rental.service';
import { SubscriptionService } from './subscription.service';
export interface TenantWithRental extends User {
  rentalTitle: string;
  rentalAddress: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private firestore: Firestore, private rentalService: RentalService, private subscriptionService: SubscriptionService) {}

  getUsers(): Observable<User[]> {
    const ref = collection(this.firestore, 'users');
    return collectionData(ref, { idField: 'id' }) as Observable<User[]>;
  }
/** All active or pending tenants */
  getTenants(): Observable<User[]> {
    return collectionData(
      query(
        collection(this.firestore, 'users'),
        where('role', '==', 'tenant'),
        where('status', 'in', ['active', 'pending'])
      ),
      { idField: 'uid' }
    ) as Observable<User[]>;
  }
assignTenant(userId: string, tenantId: string) {
  return updateDoc(doc(this.firestore, 'users', userId), {
    tenantId,
    role: 'tenant'
  });
}
  updateUser(uid: string, data: Partial<User>) {
    return updateDoc(doc(this.firestore, 'users', uid), data);
  }

  archiveTenant(uid: string) {
    return updateDoc(doc(this.firestore, 'users', uid), {
      status: 'archived',
      archivedAt: new Date()
    });
  }
getUsersWithSubscriptions(
    landlordIds: string[]
  ): Observable<{
    userName: string;
    email: string;
    status: string;
    amount: number;
    renewsOn: Date;
  }[]> {


    return combineLatest([
      this.getUsers(),
      this.subscriptionService.getSubscriptionsByLandlordIds(landlordIds)
    ]).pipe(
      map(([users, subs]) =>
        subs.map(sub => {
          const user = users.find(u => u.uid === sub.uid);

          return {
            userName: user
              ? `${user.firstName} ${user.lastName}`
              : 'Unknown',
            email: user?.email ?? '',
            status: sub.status,
            amount: sub.unitAmount / 100, // cents → dollars
            renewsOn: sub.daysUntilDue
          };
        })
      )
    );
  }
  getTenantsWithRental(): Observable<TenantWithRental[]> {
    return combineLatest([this.getTenants(), this.rentalService.getRentals()]).pipe(
      map(([users, rentals]) =>
        users
          .filter(u => u.role === 'tenant')
          .map(u => {
            const rental = rentals.find(r => r.id === u.rentalId);
            return {
              ...u,
              rentalTitle: rental?.title ?? 'Not Assigned',
              rentalAddress: rental?.address ?? 'N/A'
            };
          })
      )
    );
  }
}
